<template>
  <Category cate-name="news-commentary" category-name="時事解説" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
